import { Config as CommonConfig } from '@chew/common/config';

export interface Config extends CommonConfig {
  SENTRY_DSN: string;
}

export const { API, FACEBOOK_APP_ID, GOOGLE_CLIENT_ID, MIXPANEL_TOKEN, ENVIRONMENT, RELEASE, SENTRY_DSN } = process.env
  .CONFIG as unknown as Config;
